import * as React from "react"
import Spacer from "../components/spacer"

const IntroText = ({text}) => (
  <div >
    <Spacer className='m-hide' />
    <Spacer  className='m-hide'/>
    <p className='m0 h3 medium text-light max-1000 ma pl20 pr20'>{text}</p>
    <Spacer className='m-hide' />
    <Spacer className='m-hide'/>
  </div>
) 
export default IntroText
